import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult } from 'lit';

import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-tabs-links.css.lit';

/**
 * The Tabs Links component
 *
 * @element ghs-tabs-links
 */
@customElement('ghs-tabs-links')
export class GhsTabsLinKs extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div role="tablist" class="tabs-links-wrapper">
        <slot name="links"></slot>
      </div>
    `;
  }
}
